import React from "react";
import "twin.macro";
import {
  FaLocationArrow,
  FaUserCheck,
  FaHandshake,
  FaKeyboard,
  FaRupeeSign,
  FaTruckLoading,
} from "react-icons/fa";
import { BiCustomize } from "react-icons/bi";
import { BsGraphUp } from "react-icons/bs";
import { GoSettings } from "react-icons/go";

const LeftHeroIndustryData = [
  {
    title: "Offer letters from big MNCs.",
    icons: FaLocationArrow,
  },
  {
    title: "Got a recognition and more opportunity in the Industry.",
    icons: BsGraphUp,
  },
  {
    title: "Build a great network which helps me any time in any situation.",
    icons: FaUserCheck,
  },
  {
    title:
      "My profile got 200% boost in only last one month after teach tomatoes help.",
    icons: FaHandshake,
  },
];

const RightHeroIndustryData = [
  {
    title: "Better Client interaction.",
    icons: BiCustomize,
  },
  {
    title: "Helped best for freelancers",
    icons: BsGraphUp,
  },
  {
    title: "Special and optimized Keywords.",
    icons: FaKeyboard,
  },
  {
    title: "Unlimited Customization.",
    icons: FaRupeeSign,
  },
  {
    title: "Delivered in 24 – 72 Hrs",
    icons: FaTruckLoading,
  },
  {
    title: "Customized on Demand",
    icons: GoSettings,
  },
];

const GetIndustryStandardSection = () => {
  return (
    <div>
      <div tw="max-w-7xl font-size[20px] mx-auto my-28 space-y-4 text-white p-5">
        <div tw="space-y-3 md:text-center ">
          <p tw="text-3xl font-bold">
            Let’s take a glimpse at what our Clients got from us
          </p>
        </div>

        <div tw="grid md:grid-cols-2  place-content-center space-y-3">
          <div tw=" space-y-3 md:(space-y-10 mx-auto)">
            {LeftHeroIndustryData.map((item, index) => (
              <div tw="flex items-center space-x-2 " key={index}>
                <div tw="h-5 w-6 text-red-600">
                  <item.icons />
                </div>
                <p>{item.title}</p>
              </div>
            ))}
          </div>

          <div tw="md:mx-auto space-y-3">
            {RightHeroIndustryData.map((item, index) => (
              <div tw="flex items-center space-x-2" key={index}>
                <div tw="h-5 w-6 text-red-600">
                  <item.icons />
                </div>
                <p>{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetIndustryStandardSection;
